import { datadogLogs } from '@datadog/browser-logs';

export function logError(event) {
    datadogLogs.logger.error(event.message, event);
}

export function logInfo(event) {
    datadogLogs.logger.info(event.message, event);
}

export function addToGlobalScope(key, value) {
    datadogLogs.setGlobalContextProperty({ [key]: value });
}
